// src/components/CommonPartsList.jsx
import React from 'react';
import { PART_TYPE_LABELS } from '../types/commonParts';
import '../styles/components/CommonPartsList.scss';

const CommonPartsList = ({
    parts,
    filterType,
    onFilterTypeChange,
    onEditPart,
    onDeletePart
}) => {
    return (
        <div className="common-parts-list">
            {/* フィルター */}
            <div className="filters">
                <div className="filter-group">
                    <label htmlFor="type-filter">種類:</label>
                    <select
                        id="type-filter"
                        value={filterType}
                        onChange={(e) => onFilterTypeChange(e.target.value)}
                    >
                        <option value="all">すべて</option>
                        <option value="header">ヘッダー</option>
                        <option value="footer">フッター</option>
                        <option value="navigation">ナビゲーション</option>
                        <option value="sidebar">サイドバー</option>
                        <option value="cta">CTA</option>
                    </select>
                </div>
            </div>

            {/* パーツ一覧 */}
            <div className="parts-grid">
                {parts.length === 0 ? (
                    <div className="no-parts">
                        <p>パーツが見つかりません</p>
                        <small>フィルターを調整するか、新しいパーツを作成してください</small>
                    </div>
                ) : (
                    parts.map(part => (
                        <div key={part.id} className="part-row">
                            <div className="part-row-inner">
                                <div className="part-info">
                                    <div className="part-head">
                                        <h3 className="part-name">{part.name}</h3>
                                        <div className="part-badges">
                                            <span className={`type-badge ${part.type}`}>
                                                {PART_TYPE_LABELS[part.type]}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="part-meta">
                                        <small>
                                            作成: {new Date(part.createdAt?.toDate?.() || part.createdAt).toLocaleDateString()}
                                        </small>
                                        <small>
                                            更新: {new Date(part.updatedAt?.toDate?.() || part.updatedAt).toLocaleDateString()}
                                        </small>
                                    </div>
                                </div>
                                <div className="part-actions">
                                    <button
                                        className="edit-button"
                                        onClick={() => onEditPart(part)}
                                    >
                                        編集
                                    </button>
                                    <button
                                        className="delete-button"
                                        onClick={() => onDeletePart(part.id)}
                                    >
                                        削除
                                    </button>
                                </div>
                            </div>
                            <div className="part-preview">
                                <div className="preview-container">
                                    <div
                                        className="preview-content"
                                        dangerouslySetInnerHTML={{
                                            __html: part.html
                                        }}
                                    />
                                    {part.css && (
                                        <style>{part.css}</style>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default CommonPartsList;
